import StatusBadge from "../midpoint/intelligence/StatusBadge";
import { formatClientDate } from "../../utils/clientPortalFormat";

const PUBLISH_TONE = {
  DRAFT: "neutral",
  PENDING_REVIEW: "warning",
  APPROVED: "info",
  REJECTED: "danger",
  PUBLISHED: "success",
  ARCHIVED: "neutral",
};

const ClientContentPublishBadges = ({ item }) => {
  if (!item?.publishStatus) return null;

  return (
    <div className="client-content-publish-badges">
      <StatusBadge
        tone={PUBLISH_TONE[item.publishStatus] || "neutral"}
        label={item.publishStatusLabel || item.publishStatus}
      />
      {item.hasPendingReview ? (
        <StatusBadge tone="warning" label="Pending review" />
      ) : null}
      {item.hasDraftChanges ? (
        <StatusBadge tone="neutral" label="Draft changes" />
      ) : null}
      {item.publishStatus === "REJECTED" && item.rejectionComments ? (
        <span className="muted" title={item.rejectionComments}>
          Rejected — see feedback
        </span>
      ) : null}
      {item.publishedAt ? (
        <span className="muted">Published {formatClientDate(item.publishedAt)}</span>
      ) : null}
    </div>
  );
};

export default ClientContentPublishBadges;
